<script>
export default {
  name: "dtsDetails",
  props: {
    user: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      track: null,
      loading: false,
    };
  }, methods: {
    async getData(id) {
      this.loading = true;
      await this.$bvModal.show("modal-createDetails"); // Using a different modal ID to avoid conflicts
      this.$store.dispatch("dtstrack/GetSingleTrack", id).then((res) => {
        this.track = res.data;
        // this.getDocuments();
        this.loading = false;
      });
      this.loading = false;
    },
    getDocuments() {
      // this.$store
      //   .dispatch("dtstrackdocument/GetTrackDocument", this.track.id)
      //   .then((res) => {
      //     this.track.documents = res.data;
      //   });
    }, async updateTrack() {
      this.$emit("updateTrack", this.track);
      await this.$bvModal.hide("modal-createDetails");
    },
    async postTrack() {
      this.$emit("postTrack", this.track);
      await this.$bvModal.hide("modal-createDetails");
    },
    async unsendTrack() {
      this.$emit("unsendTrack", this.track);
      await this.$bvModal.hide("modal-createDetails");
    },
    async deleteTrack() {
      this.$emit("deleteTrack", this.track);
      await this.$bvModal.hide("modal-createDetails");
    }, async returnTrack() {
      this.$emit("returnTrack", this.track);
      await this.$bvModal.hide("modal-createDetails");
    },
    async receiveTrack() {
      this.$emit("receiveTrack", this.track);
      await this.$bvModal.hide("modal-createDetails");
    },
    async completeTrack() {
      this.$emit("completeTrack", this.track);
      await this.$bvModal.hide("modal-createDetails");
    },
    async forwardTrack() {
      let type = this.track.status == "RECEIVED" ? "received" : "completed";
      this.$emit("forwardTrack", { data: this.track, type: type });
      await this.$bvModal.hide("modal-createDetails");
    },
    async trackRating() {
      this.$emit("trackRating", this.track.id);
      await this.$bvModal.hide("modal-createDetails");
    },

    async printTrackingReport(id) {
      this.$emit("printTrackingReport", id);
    },
  },
};
</script>

<template>
  <b-modal id="modal-createDetails" title="Track Details" size="md" title-class="font-18" hide-footer
    no-close-on-backdrop>
    <div v-if="loading">
      <div class="h-50vh d-flex align-items-center justify-content-center">
        <div class="preloader-component me-2">
          <div class="status">
            <div class="spinner-chase w-25px h-25px">
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
            </div>
          </div>
        </div>
        <h5 class="mb-0">Loading...</h5>
      </div>
    </div>
    <div v-else-if="track">
      <div>
        <div v-if="user == 'office'" class="d-flex float-end">
          <button v-if="
            track.status == 'PENDING' &&
            user == 'office'
          " type="button" @click="unsendTrack()" class="btn btn-sm btn-warning d-flex align-items-center ms-2">
            <i class="bx bx-undo fs-6 me-1"></i>Unsend
          </button>
          <button type="button" @click="printTrackingReport(track.id)"
            class="btn btn-sm btn-primary d-flex align-items-center ms-2">
            <i class="bx bx-printer fs-6 me-1"></i>Print Report
          </button>
        </div>
        <div>
          <div v-if="track.referenceNumber">
            {{ track.referenceNumber }}
          </div>
          <h5 class="mb-0">
            {{ track.title }}
          </h5>
          <div>{{ track.description }}</div>
        </div>
        <hr />
        <div class="px-3">
          <i class="font-size-11">Particulars:</i>
          <ul v-for="document in track.trackDocuments" :key="document.id" class="mb-1">
            <li>{{ document.title }}</li>
          </ul>
        </div>
        <hr />
        <div class="px-3">
          <b-row class="mb-2">
            <b-col class="d-flex justify-content-between font-size-11" sm="5"><i>Destination</i>
              <div>:</div>
            </b-col>
            <b-col>
              <div v-if="!track.destinationDepartment">{{ track.destinationDeliveryUnit.name }}</div>
              <div v-else>{{ track.destinationDepartment.departmentName }} ({{ track.destinationDeliveryUnit.name }})
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="d-flex justify-content-between font-size-11" sm="5"><i>Action Requested</i>
              <div>:</div>
            </b-col>
            <b-col>
              <div>
                {{ track.actionNeeded }}
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="d-flex justify-content-between font-size-11" sm="5"><i>Process</i>
              <div>:</div>
            </b-col>
            <b-col>
              <div>
                {{ track.processType.processName }}
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="d-flex justify-content-between font-size-11" sm="5"><i>Ease of Doing Business</i>
              <div>:</div>
            </b-col>
            <b-col>
              <div>
                {{ track.processType.easeOfDoingBusinessType }}
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="d-flex justify-content-between font-size-11" sm="5"><i>Estimated Working Days</i>
              <div>:</div>
            </b-col>
            <b-col>
              <div>
                {{ track.processType.estimatedWorkingDays }}
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="d-flex justify-content-between font-size-11" sm="5"><i>Days to Remind Processor</i>
              <div>:</div>
            </b-col>
            <b-col>
              <div>
                {{ track.processType.daysToRemindOfficeProcessor }}
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col class="d-flex justify-content-between font-size-11" sm="5"><i>Created By</i>
              <div>:</div>
            </b-col>
            <b-col>
              <div class="mb-1">
                <div v-if="!track.department">{{ track.deliveryUnit.name }}</div>
                <div v-else>{{ track.department.departmentName }} ({{ track.deliveryUnit.name }})</div>
              </div>
              <div class="mb-1 font-size-11">
                {{ formatDateWithTime(new Date(track.dateTimeCreated)) }}
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-2" v-if="track.status != 'DRAFT'">
            <b-col class="d-flex justify-content-between font-size-11" sm="5"><i>Status</i>
              <div>:</div>
            </b-col>
            <b-col>
              <div v-if="track.status == 'RETURNED'">
                <span class="text-warning">RETURNED</span> to
                {{ track.deliveryUnit.name }}
              </div>
              <div v-if="track.status == 'PENDING'">
                <span class="text-info">SENT</span> to
                {{ track.destinationDeliveryUnit.name }}
              </div>
              <div v-if="track.status == 'RECEIVED'">
                <span class="text-pink">{{ track.status }}</span> by
                {{ track.destinationDeliveryUnit.name }}
              </div>
              <div v-if="track.status == 'COMPLETED'">
                <span class="text-success">PROCESSED</span> by
                {{ track.destinationDeliveryUnit.name }}
              </div>
            </b-col>
          </b-row>
        </div>
        <hr v-if="
          user == 'incoming' ||
          track.status == 'DRAFT' ||
          track.status == 'RECEIVED'
        " />
        <div class="d-flex float-end gap-2">
          <button v-if="
            (track.status == 'DRAFT' || track.status == 'RETURNED') &&
            user == 'office'
          " type="button" @click="updateTrack()" class="btn btn-sm btn-info d-flex align-items-center">
            <i class="bx bx-edit fs-6 me-1"></i>Update Track
          </button>
          <button v-if="track.status == 'DRAFT' && user == 'office'" type="button" @click="deleteTrack()"
            class="btn btn-sm btn-danger d-flex align-items-center">
            <i class="bx bx-trash fs-6 me-1"></i>Delete Track
          </button>
          <button v-if="
            (track.status == 'DRAFT' || track.status == 'RETURNED') &&
            user == 'office'
          " type="button" @click="postTrack()" class="btn btn-sm btn-success d-flex align-items-center">
            <i class="bx bx-send fs-6 me-1"></i>Send Track
          </button>
          <button v-if="
            (track.status == 'PENDING' || track.status == 'RECEIVED') &&
            user == 'incoming'
          " type="button" @click="returnTrack()" class="btn btn-sm btn-danger d-flex align-items-center">
            <i class="bx bx-undo fs-6 me-1"></i>Return Track
          </button>
          <button v-if="track.status == 'PENDING' && user == 'incoming'" type="button" @click="receiveTrack()"
            class="btn btn-sm btn-success d-flex align-items-center">
            <i class="bx bx-folder-open fs-6 me-1"></i>Receive Track
          </button>
          <button v-if="track.status == 'RECEIVED' && user == 'incoming'" type="button" @click="completeTrack()"
            class="btn btn-sm btn-success d-flex align-items-center">
            <i class="bx bx-check-circle fs-6 me-1"></i>Complete Track
          </button>
          <button v-if="
            (track.status == 'RECEIVED' || track.status == 'COMPLETED') &&
            user == 'incoming'
          " type="button" @click="forwardTrack()" class="btn btn-sm btn-info d-flex align-items-center">
            <i class="bx bx-send fs-6 me-1"></i>Forward Track
          </button>
          <button v-if="track.status == 'COMPLETED' && user == 'incoming'" type="button" @click="trackRating()"
            class="btn btn-sm btn-pink d-flex align-items-center">
            <i class="bx bx-check-circle fs-6 me-1"></i>Rate Track
          </button>
        </div>
      </div>
    </div>
  </b-modal>
</template>